/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this file will make it easier to update Pipeline.
 *
 */

(function() {
  var mobileMedia = window.matchMedia('(max-width: 767px)');

  function updateStickyCartVisibility(stickyCart) {
    var inlineButton = stickyCart.closest('.product__details').querySelector('[data-add-to-cart]');
    var isVisible = mobileMedia.matches && inlineButton.getBoundingClientRect().bottom <= 0;

    stickyCart.classList.toggle('is-visible', isVisible);
    stickyCart.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
  }

  function updateStickyCartsVisibility() {
    document.querySelectorAll('[data-product-sticky-cart]').forEach(updateStickyCartVisibility);
  }

  function initStickyCart(stickyCart) {
    if (stickyCart.hasAttribute('data-product-sticky-cart-initialized')) {
      return;
    }

    var productSection = stickyCart.closest('.product-section');
    var productForm = stickyCart.closest('.product__details').querySelector('product-form');
    var inlineButton = productForm.querySelector('[data-add-to-cart]');
    var inlineButtonText = inlineButton.querySelector('[data-add-to-cart-text]');
    var inlinePrice = productSection.querySelector('[data-product-price]') || inlineButton.querySelector('[data-button-price]');
    var inlineErrors = productForm.querySelector('[data-add-action-errors]');
    var stickyButton = stickyCart.querySelector('[data-product-sticky-submit]');
    var stickyButtonText = stickyCart.querySelector('[data-product-sticky-text]');
    var stickyPrice = stickyCart.querySelector('[data-product-sticky-price]');
    var stickyErrors = stickyCart.querySelector('[data-product-sticky-errors]');

    stickyCart.setAttribute('data-product-sticky-cart-initialized', '');

    function syncStickyCart() {
      stickyButton.disabled = inlineButton.disabled;
      stickyButtonText.textContent = inlineButtonText.textContent;
      if (inlinePrice) {
        stickyPrice.innerHTML = inlinePrice.innerHTML;
      }
      stickyButton.classList.toggle('loading', inlineButton.classList.contains('loading'));
      stickyButton.classList.toggle('has-success', inlineButton.classList.contains('has-success'));

      var hasErrors = inlineErrors.textContent.trim() && getComputedStyle(inlineErrors).display !== 'none';
      stickyErrors.textContent = hasErrors ? inlineErrors.textContent.trim() : '';
      stickyErrors.hidden = !hasErrors;
    }

    var mutationObserver = new MutationObserver(syncStickyCart);
    var errorObserver = new MutationObserver(syncStickyCart);

    mutationObserver.observe(inlineButton, {
      attributes: true,
      attributeFilter: ['class', 'disabled'],
      childList: true,
      subtree: true
    });
    errorObserver.observe(inlineErrors, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      childList: true,
      subtree: true
    });

    stickyButton.addEventListener('click', function() {
      inlineButton.click();
    });
    productForm.addEventListener('theme:variant:change', syncStickyCart);

    syncStickyCart();
    updateStickyCartVisibility(stickyCart);
  }

  function initStickyCarts(container) {
    container.querySelectorAll('[data-product-sticky-cart]').forEach(initStickyCart);
  }

  initStickyCarts(document);

  document.addEventListener('shopify:section:load', function(event) {
    initStickyCarts(event.target);
  });

  document.addEventListener('theme:scroll', updateStickyCartsVisibility);
  if (mobileMedia.addEventListener) {
    mobileMedia.addEventListener('change', updateStickyCartsVisibility);
  } else {
    mobileMedia.addListener(updateStickyCartsVisibility);
  }
})();

/*
(function() {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
*/
